module.exports = __webpack_public_path__ + "img/lg_ring_r_s_1_1.8cf57803.png";